/**
 * Eden Treaty client for the Solidafy Portal API
 *
 * Provides a fully typed HTTP client derived from the API service's Elysia app type.
 * `api` is a devDependency — only needed for the App type (type-only import).
 */
import { treaty, type Treaty } from '@elysiajs/eden';
import type { App } from 'api/src/app';

export type ApiClientConfig = Treaty.Config;

export function createApiClient(baseUrl: string, config?: ApiClientConfig) {
  return treaty<App>(baseUrl, config);
}

export type ApiClient = ReturnType<typeof createApiClient>;

export type * from './types';

/**
 * Extract a human-readable message from an Eden Treaty error.
 *
 * Eden Treaty error values are a union of:
 *   - ErrorBody  → `{ error: { message, code, status } }`
 *   - Elysia validation error → `{ type: 'validation', message?, ... }`
 */
export function edenError(
  error: { value: { error?: { message: string }; message?: string } },
  fallback: string,
): string {
  const v = error.value;
  if ('error' in v && v.error) {
    return v.error.message;
  }
  if ('message' in v && v.message) {
    return v.message;
  }
  return fallback;
}
